import * as loaders from "loaders/legacy/legacy-glTF2FileLoader";
export { loaders };
export default loaders;
